import * as React from 'react';

export const LazyFinancialSituationQuestionnaireStep = React.lazy(() => import('./component'));
